import { render, staticRenderFns } from "./DeletedClient.vue?vue&type=template&id=92692b78"
import script from "./DeletedClient.vue?vue&type=script&lang=js"
export * from "./DeletedClient.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports